import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';

export interface DiseaseSearchResult {
  id: number;
  disease: string;
  drug: string;
  medicine: string;
  tridosha: string;
  pss: string;
  planet: string;
  author: string;
  search_text: string;
}

export interface DiseaseSearchResponse {
  data: DiseaseSearchResult[];
  pagination: {
    page: number;
    limit: number;
    total: number | null;
    has_more: boolean;
  };
}

@Injectable({
  providedIn: 'root'
})
export class DiseaseSearchService {
  private apiUrl: string;

  constructor(private http: HttpClient, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  searchDiseases(keyword: string, page: number = 1, limit: number = 20): Observable<DiseaseSearchResponse> {
    return this.http.get<DiseaseSearchResponse>(`${this.apiUrl}/disease-search`, {
      params: { keyword, page, limit }
    });
  }
}
